module.exports = __webpack_public_path__ + "static/img/newTow.b2bbc84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/earnImg/newTow.png
// module id = YthC
// module chunks = 1